import styled, { css } from 'styled-components'

type PromotionProps = {
  darkTheme?: boolean
}

export const PromotionBoxesSection = styled.section<PromotionProps>`
  padding: 1.25rem 0.9375rem 2.5rem 0.9375rem;
  min-height: auto;
  width: 100%;

  ${({ darkTheme }) =>
    darkTheme &&
    css`
      background-color: #141723 !important;

      a,
      strong,
      h1,
      h2,
      h3,
      h4,
      button {
        color: #fff !important;
      }
    `}
`

export const PromotionBoxGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.6rem;

  @media (max-width: 30rem) {
    gap: 1rem 0.5rem;
  }
`
export const PromotionContainer = styled.div`
  margin: 0 auto;
  max-width: 81.875rem;
`

export const PromotionBox = styled.div`
  flex: 0 0 calc(50% - 0.5rem);
  aspect-ratio: 1 / 1;
  border-radius: 0.625rem;
  overflow: hidden;
  position: relative;
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
  img {
    object-fit: cover;
  }

  @media (min-width: 30rem) {
    flex: 0 0 calc(25% - 1.25rem);
    min-width: 13.25rem;
  }
`
